import { render, staticRenderFns } from "./CategoriesPopup.vue?vue&type=template&id=add3f66a"
import script from "./CategoriesPopup.vue?vue&type=script&lang=js"
export * from "./CategoriesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports